import React from "react";

import { Text, Video } from "@/components/elements";

import styles from "./styles.module.css";

export type DispenserDialogContentProps = {
  copy?: string;
  videoSrc?: string;
};

export const DispenserDialogContent = ({
  copy,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  videoSrc,
}: DispenserDialogContentProps) => (
  <>
    <Text size="xs" className={styles.copy}>
      {copy}
    </Text>
    <Video video="dispenserHowTo" autoplay muted controls height="full" />
  </>
);
